import 'ol/ol.css';
import {apply} from 'ol-mapbox-style';

apply('map', ' https://demo.tegola.io/styles/hot-osm.json');
